<template>
  <v-container
    id="register-view"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="10"
      >
        <v-slide-y-transition appear>
          <v-card
            class="pa-3 pa-md-10 mx-sm-auto"
            light
          >
            <v-row justify="end">
              <language-selector />

              <tooltip-btn
                icon="$logout"
                tooltip="tooltip_back_to_login"
                custom-class="ma-2"
                @click="backToLogin"
              />
            </v-row>
            <h1 class="text-center text-h2 font-weight-light">
              {{ $t('register') }}
            </h1>

            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <v-row no-gutters>
                  <v-col
                    v-for="(section, i) in sections"
                    :key="i"
                    cols="12"
                  >
                    <v-list-item three-line>
                      <v-list-item-icon class="mr-4 mt-5 mt-md-4">
                        <v-icon
                          :color="section.iconColor"
                          :large="$vuetify.breakpoint.mdAndUp"
                          v-text="section.icon"
                        />
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title
                          class="text-h4 mb-4 mt-3"
                          v-text="$t(section.title)"
                        />

                        <v-list-item-subtitle
                          class="text--secondary"
                          v-text="$t(section.text)"
                        />
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <div class="text-center">
                  <v-btn
                    v-for="(social, i) in socials"
                    :key="i"
                    :color="social.iconColor"
                    class="my-2 mr-1"
                    dark
                    depressed
                    fab
                    small
                    :href="social.href"
                  >
                    <v-icon v-text="social.icon" />
                  </v-btn>

                  <div class="my-2" />

                  <div class="text-center text-h4">
                    {{ $t('or_be_classical') }}
                  </div>

                  <validation-observer
                    ref="form"
                    v-slot="{ passes }"
                  >
                    <v-form
                      @submit.prevent="passes(register)"
                    >
                      <div
                        class="overflow-y-scroll"
                        style="max-height: 400px"
                      >
                        <edit-form
                          :user="edited_item"
                          dense
                        />
                      </div>

                      <v-checkbox
                        v-model="agree_terms"
                        class="pl-3"
                        color="secondary"
                      >
                        <template #label>
                          <span class="text-no-wrap">{{ $t("i_agree_to_the") }}</span>
                          <preambulum-informations />
                        </template>
                      </v-checkbox>

                      <v-btn
                        :disabled="!agree_terms"
                        color="secondary"
                        depressed
                        min-width="140"
                        rounded
                        type="submit"
                      >
                        {{ $t('register') }}
                      </v-btn>
                    </v-form>
                  </validation-observer>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { call, dispatch } from 'vuex-pathify'
  import LanguageSelector from '@/layouts/default/widgets/LanguageSelector'
  import PreambulumInformations from '@/layouts/default/infos/PreambulumInfo'

  export default {
    name: 'RegisterView',
    components: {
      PreambulumInformations,
      LanguageSelector,
      EditForm: () => import('@/layouts/default/edit/User'),
    },
    data: () => ({
      agree_terms: false,
      /* edited_item: {
        first_name: 'Teszt',
        last_name: 'Elek',
        birth_date: '1980-05-30',
        birth_place: 'Haza',
        mother_name: 'Anya',
        phone: '06-20-454-48567',
        mobile: '06-20-432-5678',
        address: 'Budapest',
        email: 'acfh.idomero@gmail.com',
      }, */
      edited_item: {},
      sections: [
        {
          icon: '$logbook',
          iconColor: 'primary',
          title: 'logbook',
          text: 'reg_logbook_info',
        },
        {
          icon: '$document_timeline',
          iconColor: 'secondary',
          title: 'document_store',
          text: 'reg_documents_info',
        },
        {
          icon: '$chart',
          iconColor: 'cyan',
          title: 'statistics',
          text: 'reg_statistics_info',
        },
        {
          icon: '$database_sync',
          iconColor: 'green',
          title: 'automatic_datastore',
          text: 'reg_automatic_datastore_info',
        },
      ],
      socials: [
        {
          href: process.env.VUE_APP_API_URL + '/auth/facebook',
          icon: '$facebook',
          iconColor: '#3B5998',
        },
        {
          href: process.env.VUE_APP_API_URL + '/auth/google',
          icon: '$google',
          iconColor: '#DB4437',
        },
      ],
    }),
    methods: {
      registration: call('user/registration'),
      register () {
        this.registration(this.edited_item).then(response => {
          dispatch('alert/setSnackbar', { text: 'Sikeresen regisztráltál. A bejelentkezéshez szükséges információkat elküldtük az email címedre.', type: 'success' })
          this.$router.push('/login').catch(() => {})
        }).catch(e => {
          this.$refs.form.setErrors(e)
          console.log(e)
        })
      },
      backToLogin () {
        this.$router.push('/login').catch(() => {})
      },
    },
  }
</script>

<style lang="sass">
#register-view
  .v-list-item__subtitle
    -webkic-line-clamp: initial
    -webkit-box-orient: initial

  .v-list-item__title
    font-size: 1.12rem

  .v-list-item__subtitle
    font-size: .875rem
    color: #3C4858
    line-height: 1.5em
    font-weight: 300

  .v-input--selection-controls
    margin-top: 4px
</style>
